import React from 'react';
import { Helmet } from "react-helmet";

const RefundPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Bromeli - Kertészeti Tanácsadó Blog</title>
        <meta name="description" content="Bromeli kertészeti blog - szakértői tanácsok, növényápolási tippek, fenntartható kertészeti megoldások és szezonális kerti kalauz." />
      </Helmet>

      <div className="refund-policy-container" style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px', lineHeight: '1.8' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '30px', color: '#2d5a27' }}>Visszatérítési és Elállási Szabályzat</h1>
      
      <p style={{ marginBottom: '20px' }}>Hatályos: 2024. január 1.</p>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>1. Bevezetés</h2>
        <p>Ez a Visszatérítési és Elállási Szabályzat a Bromeli Kft. (a továbbiakban: "Szolgáltató", "mi") által nyújtott szolgáltatásokra és értékesített termékekre vonatkozik. Célunk, hogy vásárlóink elégedettek legyenek, és biztosítsuk a törvényben előírt jogok érvényesítését.</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>2. Értelmező rendelkezések</h2>
        <ul>
          <li><strong>Fogyasztó:</strong> A szakmája, önálló foglalkozása vagy üzleti tevékenysége körén kívül eljáró természetes személy</li>
          <li><strong>Szolgáltató:</strong> Bromeli Kft. (1011 Budapest, Fő utca 1., adószám: 12345678-2-41)</li>
          <li><strong>Digitális tartalom:</strong> Digitális formában előállított és szolgáltatott adat, pl. e-könyv, online tanfolyam</li>
          <li><strong>Fizikai termék:</strong> Kézbesített, fizikai formában értékesített termék</li>
        </ul>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>3. Elállási jog (14 napos elállási jog)</h2>
        <p>A fogyasztó a 45/2014. (II. 26.) Korm. rendelet alapján jogosult a megvásárolt termék/szolgáltatás megrendelésétől számított <strong>14 napon belül</strong> indoklás nélkül elállni a szerződéstől.</p>
        
        <h3>3.1. Az elállási jog gyakorlásának módja</h3>
        <p>Az elállási nyilatkozatot az alábbi elérhetőségeken lehet bejelenteni:</p>
        <ul>
          <li><strong>E-mail:</strong> <a href="mailto:bromeli@hotmail.com">bromeli@hotmail.com</a></li>
          <li><strong>Postai cím:</strong> Bromeli Kft., 1011 Budapest, Fő utca 1.</li>
          <li><strong>Telefon:</strong> +36 1 234 5678</li>
        </ul>
        <p>Az elállási nyilatkozatnak tartalmaznia kell a vásárló nevét, a rendelés számát és az elállási szándékot.</p>
        
        <h3>3.2. Az elállási jog határideje</h3>
        <p>Az elállási határidő:</p>
        <ul>
          <li><strong>Fizikai termék:</strong> A termék átvételétől számított 14 nap</li>
          <li><strong>Szolgáltatás:</strong> A szerződés megkötésétől számított 14 nap</li>
          <li><strong>Digitális tartalom:</strong> A letöltés megkezdéséig, ha a fogyasztó kifejezetten kérte az azonnali teljesítést</li>
        </ul>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>4. Visszatérítés szabályai</h2>
        
        <h3>4.1. Visszatérítés összege és módja</h3>
        <p>Elállás esetén a befizetett teljes összeget visszatérítjük, beleértve a szállítási költséget is (kivéve a felárként fizetett expressz szállítást). A visszatérítés az elállási nyilatkozat beérkezésétől számított <strong>14 napon belül</strong> történik, az eredeti fizetési móddal azonos módon.</p>
        
        <h3>4.2. Visszatérítés feltételei</h3>
        <ul>
          <li>Fizikai termék esetén a terméket vissza kell küldeni a Szolgáltatónak</li>
          <li>A terméknek ép, sértetlen állapotban kell lennie</li>
          <li>A terméket a csomagolásával együtt kell visszaküldeni</li>
          <li>A visszaküldés költsége a fogyasztót terheli (kivéve, ha a termék hibás)</li>
        </ul>
        
        <h3>4.3. A visszatérítés késedelme</h3>
        <p>Ha a visszatérítés késik, a késedelem idejére a Ptk. szerinti késedelmi kamatot számítjuk fel.</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>5. Digitális tartalmakra vonatkozó külön szabályok</h2>
        <p>Digitális tartalmak (pl. e-könyvek, online tanfolyamok, prémium cikkek) esetén:</p>
        <ul>
          <li>Ha a fogyasztó kifejezetten kéri az azonnali teljesítést, az elállási jog a teljesítés megkezdésével megszűnik</li>
          <li>Ha a fogyasztó nem kéri az azonnali teljesítést, az elállási jog a 14 napos határidőn belül gyakorolható</li>
          <li>A letöltött vagy megtekintett digitális tartalom visszatérítésére nincs lehetőség</li>
          <li>Technikai hiba esetén a Szolgáltató vállalja a hiba kijavítását vagy a visszatérítést</li>
        </ul>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>6. Hibás teljesítés, szavatosság</h2>
        
        <h3>6.1. Kellék-szavatosság</h3>
        <p>Fizikai termék esetén, ha a termék hibás, a fogyasztó az alábbi jogokkal élhet:</p>
        <ul>
          <li>Kérheti a termék kijavítását</li>
          <li>Kérheti a termék kicserélését</li>
          <li>Árengedményt kérhet</li>
          <li>Elállhat a szerződéstől (visszatérítés)</li>
        </ul>
        <p>A szavatossági igény bejelentésének határideje: a hiba felfedezésétől számított 2 hónap, de legfeljebb a termék átadásától számított 2 év.</p>
        
        <h3>6.2. Termékszavatosság</h3>
        <p>Gyártó által vállalt termékszavatosság esetén a gyártó felel a termék hibájáért. A termékszavatosság időtartama a gyártó által meghatározott.</p>
        
        <h3>6.3. Jótállás</h3>
        <p>Új, tartós fogyasztási cikkek esetén a jogszabályban meghatározott jótállási kötelezettség irányadó. A jótállás időtartama a termék típusától függően 1-3 év.</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>7. Szolgáltatásokra vonatkozó külön szabályok</h2>
        <p>Kertészeti konzultációs szolgáltatások esetén:</p>
        <ul>
          <li>A konzultáció megkezdése előtt 24 órával ingyenesen lemondható</li>
          <li>24 órán belüli lemondás esetén a díj 50%-a kerül visszatérítésre</li>
          <li>A konzultáció megkezdése után nincs visszatérítés</li>
          <li>Ha a Szolgáltató törli a konzultációt, a teljes díj visszatérítésre kerül</li>
        </ul>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>8. Visszaküldés szabályai</h2>
        
        <h3>8.1. Visszaküldési cím</h3>
        <p>Bromeli Kft., Logisztikai Raktár<br/>
        1239 Budapest, Csepel, Raktár utca 5.</p>
        
        <h3>8.2. Visszaküldés költségei</h3>
        <ul>
          <li>Elállás esetén: a fogyasztót terheli a visszaküldés költsége</li>
          <li>Hibás termék esetén: a Szolgáltató viseli a visszaküldés költségét</li>
          <li>Csere esetén: a Szolgáltató viseli a visszaküldés és az új termék szállításának költségét</li>
        </ul>
        
        <h3>8.3. Visszaküldés határideje</h3>
        <p>A terméket az elállási nyilatkozat bejelentésétől számított <strong>14 napon belül</strong> vissza kell küldeni.</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>9. A visszatérítés folyamata</h2>
        <ol>
          <li>A fogyasztó bejelenti az elállási szándékát (e-mail, postai levél)</li>
          <li>A Szolgáltató visszaigazolja az elállási nyilatkozat beérkezését</li>
          <li>Fizikai termék esetén: a termék visszaérkezése után a Szolgáltató ellenőrzi az állapotát</li>
          <li>A visszatérítés 14 napon belül megtörténik az eredeti fizetési módra</li>
          <li>A fogyasztó e-mailben értesítést kap a visszatérítésről</li>
        </ol>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>10. Kizáró okok az elállási jog alól</h2>
        <p>Az elállási jog nem gyakorolható az alábbi esetekben:</p>
        <ul>
          <li>Olyan digitális tartalom esetén, amelynek teljesítése a fogyasztó kifejezett kérésére azonnali megkezdődött</li>
          <li>Hangfelvételek, videofelvételek, szoftverek esetén, ha a csomagolás felbontásra került</li>
          <li>Egészségügyi vagy higiéniai termékek esetén, ha a csomagolás felbontásra került</li>
          <li>Szolgáltatások esetén, ha a szolgáltatás teljes egészében teljesítésre került</li>
          <li>Egyedi, személyre szabott termékek esetén</li>
          <li>Romlandó vagy gyorsan romló termékek esetén</li>
        </ul>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>11. Panaszkezelés</h2>
        <p>Ha problémája van a visszatérítéssel kapcsolatban, kérjük, vegye fel velünk a kapcsolatot:</p>
        <ul>
          <li><strong>E-mail:</strong> <a href="mailto:bromeli@hotmail.com">bromeli@hotmail.com</a></li>
          <li><strong>Telefon:</strong> +36 1 234 5678</li>
          <li><strong>Postai cím:</strong> Bromeli Kft., 1011 Budapest, Fő utca 1.</li>
        </ul>
        <p>A panaszokat 30 napon belül kivizsgáljuk és írásban válaszolunk.</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>12. Fogyasztóvédelmi jogorvoslati lehetőségek</h2>
        <p>Fogyasztóvédelmi eljárás keretében a fogyasztó fordulhat:</p>
        <ul>
          <li><strong>Budapesti Békéltető Testület:</strong> 1016 Budapest, Krisztina krt. 99., https://www.bekeltetes.hu</li>
          <li><strong>Fogyasztóvédelmi Hatóság:</strong> https://fogyasztovedelem.kormany.hu</li>
          <li><strong>Európai Bizottság online vitarendezési platform:</strong> https://ec.europa.eu/consumers/odr</li>
        </ul>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>13. Kapcsolat</h2>
        <p>Ha bármilyen kérdése van a visszatérítési szabályzattal kapcsolatban, forduljon hozzánk bizalommal:</p>
        <p>Bromeli Kft.<br/>
        1011 Budapest, Fő utca 1.<br/>
        E-mail: <a href="mailto:bromeli@hotmail.com">bromeli@hotmail.com</a><br/>
        Telefon: +36 1 234 5678</p>
      </section>
      
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2d5a27', marginBottom: '15px' }}>14. A szabályzat módosítása</h2>
        <p>Fenntartjuk a jogot, hogy jelen Visszatérítési és Elállási Szabályzatot bármikor módosítsuk. A módosítások a Weboldalon történő közzététellel lépnek hatályba, és nem érintik a már megkötött szerződéseket.</p>
      </section>
      
      <footer style={{ marginTop: '40px', paddingTop: '20px', borderTop: '1px solid #ccc', textAlign: 'center', color: '#666' }}>
        <p>© 2024 Bromeli Kft. Minden jog fenntartva.</p>
      </footer>
    </div>
  
    </>);
};

export default RefundPolicy;